import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import component from './component'


const mapStateToProps = state => ({
    isEmailSent: state.emailSubscriptionForm.isSent,
    isDisabled: state.items.ids.length === 0
})

export default withRouter(connect(
    mapStateToProps,
    null
)(component))
